import { __assign } from "tslib";
import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import CommissionDetails from './Commission';
import PollDetails from './Poll';
import StatusDetails from './Status';
import JournalDetails from './Journal';
import LiteratureDetails from './Literature';
import TierDetails from './Tier';
import DefaultDetails from './Default';
export var Details = function (props) {
    var deviationType = getDeviationType(props.deviation);
    switch (deviationType) {
        case DeviationTypes.COMMISSION:
            return React.createElement(CommissionDetails, __assign({}, props));
        case DeviationTypes.POLL:
            return React.createElement(PollDetails, __assign({}, props));
        case DeviationTypes.STATUS:
            return React.createElement(StatusDetails, __assign({}, props));
        case DeviationTypes.JOURNAL:
            return React.createElement(JournalDetails, __assign({}, props));
        case DeviationTypes.LITERATURE:
            return React.createElement(LiteratureDetails, __assign({}, props));
        case DeviationTypes.TIER:
            return React.createElement(TierDetails, __assign({}, props));
        default:
            return React.createElement(DefaultDetails, __assign({}, props));
    }
};
Details.displayName = 'Details';
export default Details;
//# sourceMappingURL=Details.js.map